'use client';

import ContactEmail from '@/components/obf/ContactEmail.client';

export default function PressContactEmail() {
  return (
    <span className='pointer-events-auto'>
      <ContactEmail label='Show email' />
    </span>
  );
}
